import type { TwitterFlowTextSettings } from '../api/types';

export const DEFAULT_TWITTER_LOCALE = 'en';

export const getDefaultTextId = (texts: readonly TwitterFlowTextSettings[]): string => {
  const text = texts.find((entry) => entry.is_default) ?? texts[0];
  return text ? String(text.id) : '';
};

export const getDefaultLocale = (text: TwitterFlowTextSettings | undefined): string => {
  if (!text?.locales.length) return '';
  return text.locales.includes(DEFAULT_TWITTER_LOCALE) ? DEFAULT_TWITTER_LOCALE : text.locales[0];
};

export const findTextById = (
  texts: readonly TwitterFlowTextSettings[],
  textId: string | undefined,
): TwitterFlowTextSettings | undefined =>
  textId ? texts.find((text) => String(text.id) === String(textId)) : undefined;
